import {
  Directive, HostBinding, Inject, Input, OnInit, OnDestroy, Output, EventEmitter, AfterViewInit
} from '@angular/core';
import { SidebarDirective } from "./sidebar.directive";
import { ConfigService } from '../services/config.service';

@Directive({
  selector: "[appSidebarlink]"
})
export class SidebarLinkDirective implements OnInit, OnDestroy {

  @Input()
  public parent: string;

  @Input()
  public level: number;

  @Input()
  public hasSub: boolean;

  @Input()
  public path: string;

  @HostBinding('class.open')
  @Input()
  get open(): boolean {
    return this._open;
  }
  set open(value: boolean) {
    this._open = value;
  }

  @HostBinding('class.sidebar-group-active')
  @Input()
  get sidebarGroupActive(): boolean {
    return this._sidebarGroupActive;
  }
  set sidebarGroupActive(value: boolean) {
    this._sidebarGroupActive = value;
  }

  @HostBinding('class.nav-collapsed-open')
  @Input()
  get navCollapsedOpen(): boolean {
    return this._navCollapsedOpen;
  }
  set navCollapsedOpen(value: boolean) {
    this._navCollapsedOpen = value;
  }

  protected _open: boolean;
  protected _sidebarGroupActive: boolean;
  protected _navCollapsedOpen: boolean;

  protected sideNav: SidebarDirective;

  public constructor(
    @Inject(SidebarDirective) sideNav: SidebarDirective,
    private configService: ConfigService) {
    this.sideNav = sideNav;
  }

  public ngOnInit(): any {
    this.sideNav.addLink(this);
  }

  public ngOnDestroy(): any {
    this.sideNav.removeLink(this);
  }

  //when side menu (vertical menu) item gets clicked
  public toggle(): any {
    if (this.sideNav.config?.layout?.sidebar?.collapsed && this.level.toString() === "1" && this.hasSub) {
      this.sideNav.openLinkAfterExpand(this);

      const conf = this.sideNav.config;
      conf.layout.sidebar.collapsed = false;
      this.configService.applyTemplateConfigChange({ layout: conf.layout });

      setTimeout(() => {
        this.fireRefreshEventOnWindow();
      }, 80);
      return;
    }

    this.open = !this.open;
    if(this.open) {
      this.sideNav.closeOtherLinks(this);
    }
    if (!this.open && this.level.toString() === "1" && this.hasSub) {
      this.sidebarGroupActive = false;
    }
  }

  private fireRefreshEventOnWindow(): void {
    const evt = document.createEvent("HTMLEvents");
    evt.initEvent("resize", true, false);
    window.dispatchEvent(evt);
  }

}
